module.exports = __webpack_public_path__ + "static/media/Zafran Logo - Regular.3c86b3a5.png";